module.exports = __webpack_public_path__ + "img/daily-menu-scheduler.daf7d38c.webp";